import background from "@/assets/login/bg.webp";
import Button from "../../../shared/components/button";
import logo_alt from "@/assets/logotipo.svg";
import Checkbox from "../../../shared/components/checkbox";
import { useState, type FormEvent, useEffect } from "react";
import Input from "@/shared/components/input";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router";

export default function LoginPage() {
  const [remember, setRemember] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { login, loading, error, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/admin");
    }
  }, [user, navigate]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    await login({ email, password });
  };

  return (
    <main className="grid grid-cols-1 lg:grid-cols-4 min-h-screen">
      <section
        className="hidden lg:block lg:col-span-3 relative"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <a href="/">
          <img
            className="mt-10 ml-10 lg:mt-20 lg:ml-20 h-10 lg:h-12 w-auto relative z-20"
            src={logo_alt}
            alt="Logo"
          />
        </a>
        <div className="absolute z-10 top-[85%] left-[75%] -translate-x-1/2 -translate-y-1/2 w-28 h-28 lg:w-32 lg:h-32 bg-black rounded-full shadow-2xl" />
      </section>
      <section className="lg:col-span-1 flex items-center justify-center px-6 sm:px-10 md:px-20 py-12 bg-black">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-sm lg:max-w-none gap-y-8 lg:gap-y-20 grid"
        >
          <div className="lg:hidden flex justify-center mb-8">
            <a href="/">
              <img className="h-10 w-auto" src={logo_alt} alt="Logo" />
            </a>
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold text-center lg:text-left text-white">
            Acceder
          </h1>

          <div className="grid gap-y-6">
            <Input
              label={"Email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Input
              type="password"
              label={"Contraseña"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && (
              <p className="text-red-500 text-xs mt-2">
                {error.message || "Error al iniciar sesión"}
              </p>
            )}

            <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
              <Button
                variant="ghost"
                className="p-0 h-auto font-normal text-xs lg:text-sm text-white/60 hover:text-white"
              >
                ¿Lo olvidaste?
              </Button>
              <Checkbox
                label="Recordarme"
                checked={remember}
                onChange={() => setRemember(!remember)}
                className="text-white/60"
              />
            </div>
          </div>
          <Button
            variant="primary"
            submit
            className="w-full py-4 text-xs lg:text-sm tracking-widest font-bold"
            disabled={loading}
          >
            {loading ? "CARGANDO..." : "ENTRAR"}
          </Button>
        </form>
      </section>
    </main>
  );
}
